module.exports = "/assets/3e30e7e8dc9c8aac8b1fed88c55c34c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NK.png
// module id = 1649
// module chunks = 0